export enum AdjustmentEntities {
  Payment,
  Benefit,
}
